var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadQuestions = function SvgUploadQuestions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.667 10.5a.833.833 0 0 1 .833.833v3.334a1.666 1.666 0 0 1-1.667 1.666H2.167A1.667 1.667 0 0 1 .5 14.667v-3.334a.833.833 0 0 1 1.667 0v3.334h11.666v-3.334a.833.833 0 0 1 .834-.833M8.737.895l3.388 3.388a.834.834 0 1 1-1.178 1.179L8.833 3.35v7.983a.833.833 0 0 1-1.666 0V3.35L5.053 5.462a.833.833 0 0 1-1.178-1.179L7.263.895a1.04 1.04 0 0 1 1.474 0"
  })));
};
export default SvgUploadQuestions;